import { useMemo } from "react";

export function useTestPartner() {
  const userRole = localStorage.getItem("userRole");
  const isTestPartner = useMemo(() => userRole === "test-partner", [userRole]);
  
  return {
    isTestPartner,
    canWrite: !isTestPartner,
    canRead: true,
  };
}

